import React from 'react';
import { FlagOutlined } from '@ant-design/icons';

const Icon = function (props) {
    return <FlagOutlined />;
}

export default Icon;